// extracted by mini-css-extract-plugin
export default {"overlay":"overlay--K4ju6CJkEN"};